export default [
  {
    title: "ملف المنظمة",
    route: "ngo-profile",
    icon: "HomeIcon",
    slug: "ngo-profile",
  },
];
